<template>
  <div>
    <h4 class="card-title text-center">Activation</h4>
    <p class="card-text">Please wait a seconds.</p>
    <div class="text-center">
      <loading-container :loading="true"></loading-container>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import InputText from '@/components/Form/InputText';
  import FormButton from '@/components/Form/FormButton';
  import AlertBox from '@/components/Misc/AlertBox';
  import LoadingContainer from "@/components/Misc/LoadingContainer";

  export default {
    name: "RegisterActive",
    components: {
      LoadingContainer,
      InputText,
      FormButton,
      AlertBox,
    },
    beforeMount() {
      const query = this.$route.query;
      const token = query.token;
      this.registerActivateToken(token);
    },
    computed: {
      ...mapGetters({
        form: 'auth/form',
      }),
    },
    methods: {
      ...mapActions({
        registerActivateToken: 'auth/registerActivateToken',
      }),
    },
  };
</script>
